<div class="sibling__wrapper" >
    <section class="component component--story-sibling-block sibling-block">
        <div class="wrapper">		
            <div class="row">
                <div class="col-sm-12 ">
                    <h3 class="sibling-title" *ngIf="'' != siblingTitle" [innerHtml]="siblingTitle"></h3>
                    <div class="data-listing">
                        <span class="sibling-item-span" *ngFor="let sibling of siblingContent">
                            <a class="sibling-item{{ sibling.class }}" routerLink="/{{ sibling.link }}" [innerHtml]="sibling.title"></a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>